import { render } from "./StageMaterial.vue?vue&type=template&id=c6119970&scoped=true"
import script from "./StageMaterial.vue?vue&type=script&lang=js"
export * from "./StageMaterial.vue?vue&type=script&lang=js"

import "./StageMaterial.vue?vue&type=style&index=0&id=c6119970&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6119970"]])

export default __exports__